module.exports = __webpack_public_path__ + "img/icon_arrow.562c9026.svg";